/*
 * Hero Slideshow (Product) — Slick slider init
 * Used by sections/otsb-slideshow-hero.liquid via snippets/otsb-slideshow-hero-base.liquid
 *
 * Reads configuration from data-* attributes on the slider wrapper:
 *   data-ohs-slider     — marker (presence)
 *   data-ohs-autoplay   — "true" / "false"
 *   data-ohs-speed      — autoplay interval (ms)
 *   data-ohs-arrows     — "true" / "false"
 *   data-ohs-dots       — "true" / "false"
 *   data-ohs-fade       — "true" / "false"
 *
 * Behaviour: NOT an infinite loop. When the last slide is reached, after the
 * normal autoplay interval the slider rewinds to the first slide.
 */
(function () {
  function readBool(v) { return v === true || v === 'true' || v === '1'; }

  function initSlider($el) {
    if (!$el || !$el.length || $el.hasClass('slick-initialized')) return;

    var autoplay = readBool($el.data('ohs-autoplay'));
    var speed    = parseInt($el.data('ohs-speed'), 10) || 6000;
    var arrows   = readBool($el.data('ohs-arrows'));
    var dots     = readBool($el.data('ohs-dots'));
    var fade     = readBool($el.data('ohs-fade'));

    $el.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: arrows,
      dots: dots,
      autoplay: autoplay,
      autoplaySpeed: speed,
      fade: fade,
      speed: 600,
      pauseOnHover: false,
      pauseOnFocus: false,
      adaptiveHeight: false,
      infinite: false
    });

    // Rewind to first slide after reaching the last one (autoplay only).
    $el.on('afterChange', function (e, slick, current) {
      if (autoplay && current === slick.slideCount - 1) {
        setTimeout(function () {
          if ($el.hasClass('slick-initialized')) {
            $el.slick('slickGoTo', 0);
          }
        }, speed);
      }
    });
  }

  function initAll() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick !== 'function') {
      return setTimeout(initAll, 100);
    }
    window.jQuery('[data-ohs-slider]').each(function () {
      initSlider(window.jQuery(this));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    if (!window.jQuery) return;
    var $sec = window.jQuery(e.target).find('[data-ohs-slider]');
    if ($sec.length) initSlider($sec);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!window.jQuery) return;
    var $sec = window.jQuery(e.target).find('[data-ohs-slider]');
    if ($sec.length && $sec.hasClass('slick-initialized')) {
      $sec.slick('unslick');
    }
  });
})();
